import React, { useState, useEffect } from "react";
import "../css/AccountsManageUsers.css";
import { getDocs, collection, deleteDoc, doc } from "firebase/firestore";
import { db } from "../firebase-config";
import LoadingSpinner from '../assets/LoadingSpinner';
import { HiChevronDoubleLeft, HiChevronDoubleRight, HiChevronLeft, HiChevronRight } from "react-icons/hi";

const AccountsManageUsers = () => {
    const [users, setUsers] = useState([]);
    const [isLoading, setIsLoading] = useState(true);

         // Pagination state
         const [currentPage, setCurrentPage] = useState(1);
         const itemsPerPage = 20; // Adjust this value for more/less items per page

    useEffect(() => {
        const fetchUsers = async () => {
            try {
                const querySnapshot = await getDocs(collection(db, "users"));
                const usersData = querySnapshot.docs.map(doc => ({
                    id: doc.id,
                    ...doc.data(),
                    dateCreated: doc.get('dateCreated')?.toDate()
                }));
                usersData.sort((a, b) => a.email.localeCompare(b.email));
                setUsers(usersData);
                setIsLoading(false);
            } catch (error) {
                console.error("Error fetching users:", error);
                setIsLoading(false);
            }
        };

        fetchUsers();
    }, []);

    const handleDelete = async (userId) => {
        const confirmDelete = window.confirm("Are you sure you want to delete this user?");
        if (confirmDelete) {
            try {
                const userDoc = doc(db, "users", userId);
                await deleteDoc(userDoc);
                setUsers(prevUsers => prevUsers.filter(user => user.id !== userId)); // Remove the deleted user from the UI
                alert("User deleted successfully");
            } catch (error) {
                console.error("Error deleting user: ", error);
                alert("Error deleting user");
            }
        }
    };

         // Calculate paginated data
         const indexOfLastItem = currentPage * itemsPerPage;
         const indexOfFirstItem = indexOfLastItem - itemsPerPage;
         const currentItems = users.slice(indexOfFirstItem, indexOfLastItem);
       
         // Total pages
         const totalPages = Math.ceil(users.length / itemsPerPage);
       
         const handlePageChange = (newPage) => {
           if (newPage >= 1 && newPage <= totalPages) {
             setCurrentPage(newPage);
           }
         };
     

    if (isLoading) {
        return <LoadingSpinner isVisible={true} />;
    }

    return (
        <div className="accounts-manage-users">
            <h1 className="header-manageusers">Manage Users</h1>
            <table>
                <thead>
                    <tr>
                        <th>Email</th>
                        <th>User Type</th>
                        <th>Date Created</th>
                        {/* <th>Actions</th> */}
                    </tr>
                </thead>
                <tbody>
                    {currentItems.map((user) => (
                        <tr key={user.id}>
                            <td>{user.email}</td>
                            <td>{user.usertype}</td>
                            <td>{user.dateCreated?.toLocaleDateString()}</td>
                            {/* <td>
                                <button className="delete-manageusers" onClick={() => handleDelete(user.id)}>Delete</button>
                            </td> */}
                        </tr>
                    ))}
                </tbody>
            </table>

             {/* Pagination Controls */}
             <div className="pagination-controls">
            <button className="paginationButton"
              onClick={() => handlePageChange(1)} 
              disabled={currentPage === 1}
            >
              <HiChevronDoubleLeft />
            </button>
            <button className="paginationButton"
              onClick={() => handlePageChange(currentPage - 1)} 
              disabled={currentPage === 1}
            >
              <HiChevronLeft />
            </button>
            <span>Page {currentPage} of {totalPages}</span>
            <button className="paginationButton"
              onClick={() => handlePageChange(currentPage + 1)} 
              disabled={currentPage === totalPages}
            >
              <HiChevronRight />
            </button>
            <button className="paginationButton"
              onClick={() => handlePageChange(totalPages)} 
              disabled={currentPage === totalPages}
            >
              <HiChevronDoubleRight />
            </button>
          </div>
        </div>
    );
};

export default AccountsManageUsers;